import React from 'react';
export default function AuthLogo() {
    var logo = require('assets/img/bizplay-logo.png');
    return (React.createElement("div", { className: "token-authentication__logo text-align-center" },
        React.createElement("img", { src: logo, alt: "Game Logo" })));
}
;
